import { render } from "./BaseInputField.vue?vue&type=template&id=dc8011a0"
import script from "./BaseInputField.vue?vue&type=script&lang=js"
export * from "./BaseInputField.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__